import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const AiBox = ({ title, meta, copyText, onDismiss, children }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      setCopied(false);
    }
  };

  return (
    <div className="rounded-2xl border border-violet-200 bg-violet-50/60 p-4 space-y-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-violet-700">
            <SafeIcon icon={FiIcons.FiStar} /> {title}
          </p>
          <p className="mt-0.5 text-[11px] text-violet-700/80">
            AI suggestion from your own notes. It is not part of your memory and is not saved.
          </p>
        </div>
        <button type="button" onClick={onDismiss} className="p-1.5 rounded-lg text-violet-400 hover:bg-violet-100" aria-label="Dismiss">
          <SafeIcon icon={FiIcons.FiX} />
        </button>
      </div>
      <div className="space-y-3 text-sm text-slate-700">{children}</div>
      <div className="flex items-center justify-between gap-3 pt-1">
        <p className="text-[11px] text-violet-700/70">
          {meta?.model ? `Generated by OpenAI · ${meta.model}` : ''}
        </p>
        {copyText && (
          <button type="button" onClick={copy} className="flex items-center gap-1 text-xs font-semibold text-violet-700 hover:underline">
            <SafeIcon icon={FiIcons.FiCopy} /> {copied ? 'Copied' : 'Copy'}
          </button>
        )}
      </div>
    </div>
  );
};

export const AiSection = ({ label, children }) => (
  <div>
    <p className="text-[11px] font-bold uppercase tracking-wider text-violet-700/80 mb-1">{label}</p>
    {children}
  </div>
);

export const AiBullets = ({ items }) => (
  <ul className="list-disc pl-5 space-y-1">
    {items.map((t, i) => <li key={i} className="break-words">{t}</li>)}
  </ul>
);